import script from "./UploadTradePassportBannerModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadTradePassportBannerModal.vue?vue&type=script&lang=ts&setup=true"

import "./UploadTradePassportBannerModal.vue?vue&type=style&index=0&id=1bcd40b3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bcd40b3"]])

export default __exports__